/**
 * RTWO Native Currency Engine — Null Protocol Adapter
 */

import type { CurrencyId, FeePolicyId } from '../domain-models';
import type { IProtocolAdapter, ProtocolAdapterStatus } from './protocol-adapter-interface';

export class NullProtocolAdapter implements IProtocolAdapter {
  readonly adapterId = 'null-protocol-adapter';
  readonly adapterName = 'Null Protocol Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): ProtocolAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  isGenesisConfigured(): boolean {
    return false;
  }

  async registerCurrency(_symbol: string, _name: string, _decimals: number) {
    return null;
  }

  async configureFeePolicy(
    _currencyId: CurrencyId,
    _baseFeePolicy: string,
    _priorityFeePolicy: string,
    _burnFeePolicy: string,
    _validatorFeePolicy: string
  ) {
    return null;
  }

  async validateCurrency(_currencyId: CurrencyId) {
    return null;
  }

  async validateFeePolicy(_feePolicyId: FeePolicyId) {
    return null;
  }
}
